/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MfaCode
 */
export interface MfaCode {
    /**
     * 
     * @type {string}
     * @memberof MfaCode
     */
    mfaCode: string;
}

/**
 * Check if a given object implements the MfaCode interface.
 */
export function instanceOfMfaCode(value: object): value is MfaCode {
    if (!('mfaCode' in value) || value['mfaCode'] === undefined) return false;
    return true;
}

export function MfaCodeFromJSON(json: any): MfaCode {
    return MfaCodeFromJSONTyped(json, false);
}

export function MfaCodeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MfaCode {
    if (json == null) {
        return json;
    }
    return {
        
        'mfaCode': json['mfaCode'],
    };
}

export function MfaCodeToJSON(json: any): MfaCode {
    return MfaCodeToJSONTyped(json, false);
}

export function MfaCodeToJSONTyped(value?: MfaCode | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'mfaCode': value['mfaCode'],
    };
}

